import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userLocationSlice from "./userLocation/userLocationSlice";
import userProfileSlice from "./userProfile/userProfileSlice";
import countriesSlice from "./countries/countriesSlice";
import messageSlice from "./message/messageSlice";

const rootReducer = combineReducers({
  userLocationSlice,
  userProfileSlice,
  countriesSlice,
  messageSlice,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
